export default "__VITE_ASSET__B0bFiLe8__"